import * as React from 'react'

import { IItemCard } from '../interface'

import LockupKeyFeatures from '../lockupKeyFeatures'

import CommonItemCardLayout from '../commonItemCardLayout'

const ThemeForestItemCard = (props: IItemCard) => {
  const { term = '' } = props.locationParams
  return (
    <CommonItemCardLayout carousel {...props}>
      <LockupKeyFeatures {...props} term={term} />
    </CommonItemCardLayout>
  )
}

export default ThemeForestItemCard
